export default Object.freeze({
  COVER_LETTER: Object.freeze({ MAX_CHARACTERS: 1000, MATCHING_RATE_WARNING: 60 })
});
